import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const DEFAULT_SPORT = 'Badminton';

/** Redirect legacy /coach/player/:playerId/performance/* URLs to Player Training / Player Ranking flows. */
const CoachStudentPerformanceLegacyRedirect: React.FC = () => {
  const { playerId, metric } = useParams<{ playerId: string; metric?: string }>();
  const safePlayerId = playerId || '';
  const m = metric || '';

  if (m.startsWith('ranking-') || m === 'self-evaluation' || m === 'coach-academy' || m === 'practical-test') {
    const categoryMap: Record<string, string> = {
      'ranking-self': 'self-evaluation',
      'ranking-coach': 'coach-academy',
      'ranking-practical': 'practical-test',
      'self-evaluation': 'self-evaluation',
      'coach-academy': 'coach-academy',
      'practical-test': 'practical-test',
    };
    const category = categoryMap[m] || 'coach-academy';
    return (
      <Navigate
        to={`/coach/player-ranking/${DEFAULT_SPORT}/${category}?player=${encodeURIComponent(safePlayerId)}`}
        replace
      />
    );
  }

  return (
    <Navigate
      to={`/coach/player-training/${DEFAULT_SPORT}/skill-assessment-beginner-coach?player=${encodeURIComponent(safePlayerId)}`}
      replace
    />
  );
};

export default CoachStudentPerformanceLegacyRedirect;
